export { default } from './NavbarProductNews';
